import { makeObservable, action } from 'mobx'
import BaseStore from 'stores/base'

export default class SharedProposalStore extends BaseStore {
    constructor(service) {
        super(service)

        makeObservable(this, {
            getSharedProposal: action,
        })
    }

    async getSharedProposal(key) {
        return this.getRequest(this.Table, () => this.service.getSharedProposal(key), data => {
            this.Table.data = {
                proposal: {
                    proposalBundles: data.proposal.proposalBundles,  // ← fixed
                    prData: data.prDetails,     // ← fixed
                    currencySymbol: data.proposal.currencySymbol,     // ← added
                    currencyCode: data.proposal.currencyCode,
                    settings: data.prDetails.purchaseRequest.settings || {} ,
                    language: data.language        // ← added
                },
                resource: data.resource                               // ← added
            }
        })
    }
}